const countryCodes = {
  US: 'US',
  GB: 'GB',
  CA: 'CA',
};

export default countryCodes;
